import CallCenterForm from './_form'
import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCenterForm
  },
  data() {
    return {
      lastPath: null,
      lastPathParams: {},
      errors: {}
    }
  },
  beforeRouteEnter(_to, from, next) {
    // se añade el nombre de la ultima dirección, ya que, el boton cancelar debe redirigir
    // a la ultima dirección si esta es el listado de operadores o la creación de operadores
    next(vm => {
      if (['operators-index', 'operators-new', 'operators-edit'].includes(from?.name)) {
        vm.lastPathParams = from.params
        vm.lastPath = from.name
      }
    })
  },
  created() {
    this.$setPageTitle(this.$t('programationReport.new.title'))
    this.$setBreadcrumbs([
      // eslint-disable-next-line max-len
      {label: this.$t('breadcrumbs.programationReport.index'), route: {name: 'programation-report-index'}},
      {label: this.$t('breadcrumbs.programationReport.new'), route: {}}
    ])
  },
  methods: {
    createCallCenter(data) {      
      API.programationReport.create(data).then(() => {
        this.$notifications.success(this.$t('programationReport.new.succesfullyCreated'))
        this.$router.push({
          name: this.lastPath || 'programation-report-index',
          params: this.lastPathParams
        })
      }, errors => {
        this.errors = errors
      })
    }
  }
})
